import React, { Component } from 'react'
import { Card, PageHeader, Row, Col } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import AdoptionApplicationList from '../../components/AdoptionApplicationList'
import { AdoptionApplicationForm } from '../../components/Forms'
import { ShelterProvider, ShelterConsumer } from '../../context/ShelterContext'
import { AdoptionApplicationProvider, AdoptionApplicationConsumer } from '../../context/AdoptionApplicationContext'
import { IntegrationConsumer, IntegrationProvider } from '../../context/IntegrationContext'
import { IntegrationPartnerConsumer, IntegrationPartnerProvider } from '../../context/IntegrationPartnerContext'

export default class AdoptionApplication extends Component {

  private adoptionFilterDispatchOptions = {
    search: {
      adopter_user: {
        with: { deleted: false, _exists: true }
      },
      adoption_return: {
        with: true
      },
      pet: {
        with: {
          _exists: true,
          branch: {
            with: {
              _exists: true,
              shelter: {
                with: true
              }
            }
          }
        }
      }
    },
    options: {
      sort: []
    }
  } as const

  adoptionListSearch = {
    search: {
      adopter_user: {
        with: { deleted: false, _exists: true }
      },
      adoption_return: {
        with: true
      },
      pet: {
        with: {
          _exists: true,
          branch: {
            with: {
              _exists: true,
              shelter: {
                with: true
              }
            }
          }
        }
      }
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.adoptionListSearch.search = payload.search
    }
  }

  render() {
    const { permissions, history, goBack, match: { params: { applicationUuid } } }: any = this.props

    return (
      <ShelterProvider>
        <AdoptionApplicationProvider>
          <ShelterConsumer>
            {({ fetching: fetchingShelters, shelters, requestShelterList }) => (
              <AdoptionApplicationConsumer>
                {({ fetching, error, applications, application, pagination, requestAdoptionApplicationList, requestAdoptionApplicationFind, requestAdoptionApplicationCheckoutUpdate, requestAdoptionApplicationCheckoutRemoveProduct, requestAdoptionApplicationReturn, requestAdoptionApplicationForceSetAdopted }) => {
                  const statusToFilter = [
                    {
                      value: 'ADOPTED',
                      text: 'ADOPTED'
                    },
                    {
                      value: 'APPROVED',
                      text: 'APPROVED'
                    },
                    {
                      value: 'DECLINED',
                      text: 'DECLINED'
                    },
                    {
                      value: 'PAID',
                      text: 'PAID'
                    },
                    {
                      value: 'PENDING',
                      text: 'PENDING'
                    },
                    {
                      value: 'SIGNED',
                      text: 'SIGNED'
                    },
                    {
                      value: 'UNDER_REVIEW',
                      text: 'UNDER_REVIEW'
                    }
                  ]

                  const canceledToFilter = [
                    {
                      value: { isNotNull: true },
                      text: 'Yes'
                    },
                    {
                      value: { isNull: true },
                      text: 'No'
                    }
                  ]

                  const loadSheltersDispatch = (args: any) => requestShelterList({
                    search: {
                      ...args,
                      organization_branches: {
                        with: true
                      }
                    },
                    options: {
                      sort: [
                        '-organization_branches.name'
                      ]
                    }
                  })

                  const branchesToFilter = [] as any
                  shelters?.forEach(shelter => {
                    shelter.organization_branches?.forEach(branch => {
                      const exists = branchesToFilter.find(p => p.value === branch.uuid)
                      if (!exists) {
                        branchesToFilter.push({
                          value: branch.uuid,
                          text: `${branch.name} / ${shelter.name}`
                        })
                      }
                    })
                  })

                  // Edit application
                  if (applicationUuid) {
                    return (
                      <Card>
                        <PageHeader title="Edit Adoption Application" onBack={() => goBack('/organization/adoption-application')}>
                          <AdoptionApplicationForm
                            uuid={applicationUuid}
                            data={application}
                            permissions={permissions}
                            loading={fetching}
                            error={error}

                            loadAdoptionApplication={requestAdoptionApplicationFind}
                            adoptionApplicationCheckoutUpdate={requestAdoptionApplicationCheckoutUpdate}
                            adoptionApplicationCheckoutRemoveProduct={requestAdoptionApplicationCheckoutRemoveProduct}
                          />
                        </PageHeader>
                      </Card>
                    )
                  }

                  return (
                    <>
                      <Card title="Filters" style={{marginBottom: 25}}>
                        <Filters size="small" loading={fetching || fetchingShelters} history={history} defaultSubmitOptions={this.adoptionFilterDispatchOptions} submitDispatch={requestAdoptionApplicationList} dispatches={[loadSheltersDispatch]} onSubmit={this.handleFiltersSubmit}>
                          {({ values, handleFilterChange }: any) => (
                            <Row gutter={9} style={{width: '100%'}}>
                              <Col xs={24} md={4}>
                                <FilterItem
                                  name="uuid"
                                  type={Types.INPUT}
                                  placeholder="UUID"
                                  value={values['uuid']}
                                  size="small"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                              <Col xs={24} md={4}>
                                <FilterItem
                                  name="pet.with.name.ilike"
                                  type={Types.INPUT}
                                  placeholder="Pet Name"
                                  value={values['pet.with.name.ilike']}
                                  size="small"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={4}>
                                <FilterItem
                                  name="adopter_user.with.email.ilike"
                                  type={Types.INPUT}
                                  placeholder="Adopter Email"
                                  value={values['adopter_user.with.email.ilike']}
                                  size="small"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={5}>
                                <FilterItem
                                  name="pet.with.branch.with.uuid"
                                  type={Types.SELECT}
                                  placeholder="Location / Shelter"
                                  data={branchesToFilter}
                                  value={values['pet.with.branch.with.uuid']}
                                  size="small"
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={4}>
                                <FilterItem
                                  name="status_key"
                                  type={Types.SELECT}
                                  placeholder="Status"
                                  data={statusToFilter}
                                  value={values['status_key']}
                                  size="small"
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={3}>
                                <FilterItem
                                  name="canceled"
                                  type={Types.SELECT}
                                  placeholder="Canceled"
                                  data={canceledToFilter}
                                  value={values['canceled']}
                                  size="small"
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                            </Row>
                          )}
                        </Filters>
                      </Card>

                      <Card title="List of Applications">
                        <IntegrationProvider>
                          <IntegrationPartnerProvider>
                            <IntegrationConsumer>
                              {(integrationContext) => (
                                <IntegrationPartnerConsumer>
                                  {(integrationPartnerContext) => (
                                    <AdoptionApplicationList
                                      permissions={permissions}
                                      loading={fetching}
                                      applications={applications}
                                      pagination={pagination}
                                      history={history}
                                      searchOptions={this.adoptionListSearch}
                                      integrationContext={integrationContext}
                                      integrationPartnerContext={integrationPartnerContext}
                                      loadAdoptionApplications={requestAdoptionApplicationList}
                                      adoptionApplicationReturn={requestAdoptionApplicationReturn}
                                      adoptionApplicationForceSetAdopted={requestAdoptionApplicationForceSetAdopted}
                                    />
                                  )}
                                </IntegrationPartnerConsumer>
                              )}
                            </IntegrationConsumer>
                          </IntegrationPartnerProvider>
                        </IntegrationProvider>
                      </Card>
                    </>
                  )
                }}
              </AdoptionApplicationConsumer>
            )}
          </ShelterConsumer>
        </AdoptionApplicationProvider>
      </ShelterProvider>
    )
  }
}
